import React, {Suspense} from "react"
import {CircularProgress, Link, Typography} from "@mui/material"
import CheckboxWidget from "../../anwendungskonfigurator/content/widgets/CheckboxWidget"
import ChildrenSelectWidget from "../../anwendungskonfigurator/content/widgets/ChildrenSelectWidget"
import ChildrenSelectWithEnumWidget from "../../anwendungskonfigurator/content/widgets/ChildrenSelectWithEnumWidget"
import WidgetInputCurrency from "../../anwendungskonfigurator/content/widgets/WidgetInputCurrency"
import DatePicker from "../../anwendungskonfigurator/content/widgets/DatePicker"
import YearPicker from "../../anwendungskonfigurator/content/widgets/YearPicker"
import WidgetDndBoard from "../../anwendungskonfigurator/content/widgets/WidgetDndBoard"
import WysiwygEditorWidget from "../../anwendungskonfigurator/content/widgets/WysiwygEditorWidget"
import SelectWidget from "../../anwendungskonfigurator/content/widgets/SelectWidget"
import BaseTextInput from "../../anwendungskonfigurator/content/widgets/BaseTextInput"
import ImageWidget from "../../anwendungskonfigurator/content/widgets/ImageWidget"
import ImportFileButtonWidget from "../../anwendungskonfigurator/content/widgets/ImportFileButtonWidget"
import LabelWidget from "../../anwendungskonfigurator/content/widgets/LabelWidget"
import LongText from "../../anwendungskonfigurator/content/widgets/LongText"
import MultiSelectWidget from "../../anwendungskonfigurator/content/widgets/MultiSelectWidget"
import PercentWithTwoDecimal from "../../anwendungskonfigurator/content/widgets/PercentWithTwoDecimal"
import ObjektToWidgets from "../../anwendungskonfigurator/content/widgets/ObjektToWidgets"
import StackedBarchartWidget
    from "../../anwendungskonfigurator/content/widgets/stacked-barchart-widget/StackedBarchartWidget"
import SwitchWidget from "../../anwendungskonfigurator/content/widgets/SwitchWidget"
import ValueWidget from "../../anwendungskonfigurator/content/widgets/ValueWidget"
import ChartDonutWidget from "../../anwendungskonfigurator/content/widgets/ChartDonutWidget"
import ZielscheibeWidget from "../../anwendungskonfigurator/content/widgets/ZielscheibeWidget"
import WidgetTimelineBoard from "../../anwendungskonfigurator/content/widgets/WidgetTimelineBoard"
import DartHoneyWidget from "../../anwendungskonfigurator/content/widgets/HoneyComb/DartHoneyWidget"
import HoneyWidget from "../../anwendungskonfigurator/content/widgets/HoneyComb/HoneyWidget"
import WidgetObjectList from "../../anwendungskonfigurator/content/widgets/WidgetObjectList"
import DialogMilestoneContent from "../../anwendungskonfigurator/components/dialoge/DialogMilestoneContent"
import VerticalSliderWidget from "../../anwendungskonfigurator/content/widgets/VerticalSliderWidget"
import HorizontalSliderWidget from "../../anwendungskonfigurator/content/widgets/HorizontalSliderWidget"
import BadgeWidget from "../../anwendungskonfigurator/content/widgets/BadgeWidget"
import BadgeEvaluationWidget from "../../anwendungskonfigurator/content/widgets/BadgeEvaluationWidget"
import MultiDropdownWidget from "../../anwendungskonfigurator/content/widgets/MultiDropdownWidget"
import SegmentButtonWidget from "../../anwendungskonfigurator/content/widgets/SegmentButton/SegmentButtonWidget"
import RadiobuttonGroupWidget from "../../anwendungskonfigurator/content/widgets/RadiobuttonGroupWidget"
import {
    VersorgungslueckenVerlaufChart,
} from "../../anwendungskonfigurator/content/widgets/VersorgungslueckenVerlauf/VersorgungslueckenVerlaufChart"
import WidgetDot from "../../anwendungskonfigurator/content/widgets/WidgetDot"
import WidgetTeTable from "../../anwendungskonfigurator/content/widgets/WidgetTeTable"
import IconButtonOutlined from "../../anwendungskonfigurator/content/widgets/IconButtonOutlined"
import PrimaryButtonWidget from "./../../anwendungskonfigurator/content/widgets/buttons/PrimaryButtonWidget"
import SecondaryButtonWidget from "./../../anwendungskonfigurator/content/widgets/buttons/SecondaryButtonWidget"
import TertiaryButtonWidget from "./../../anwendungskonfigurator/content/widgets/buttons/TertiaryButtonWidget"
import GhostButtonWidget from "./../../anwendungskonfigurator/content/widgets/buttons/GhostbuttonWidget"
import WorkflowButtonWidget from "./../../anwendungskonfigurator/content/widgets/buttons/WorkflowButtonWidget"
import Video from "./../../anwendungskonfigurator/content/widgets/Video"
import IconButtonWidget from "../../anwendungskonfigurator/content/widgets/buttons/IconButtonWidget"
import WidgetLogo from "./Widget/WidgetLogo"
import WidgetLink from "./../../anwendungskonfigurator/content/widgets/LinkWidget"
import {
    AltersvorsorgeberatungTable,
} from "../../anwendungskonfigurator/content/widgets/Altersvorsorgeberatung/AltersvorsorgeberatungTable"
import ImageCardProgressWidget
    from "./../../anwendungskonfigurator/content/widgets/ImageFileWithProgress/ImageCardProgressWidget"
import IconCardWidget from "./../../anwendungskonfigurator/content/widgets/IconCardWidget"
import FrageListWidget from "./../../anwendungskonfigurator/content/widgets/FrageListeWidget/WidgetFrageList"
import WidgetWeltBoard from "./../../anwendungskonfigurator/content/widgets/WeltBoardWidget/WeltBoardWidget"
import HeroUnitWidget from "./../../anwendungskonfigurator/content/widgets/HeroUnitWidget"
import IconWidget from "./../../anwendungskonfigurator/content/widgets/IconWidget"
import {LebenssituationBild} from "../../anwendungskonfigurator/content/widgets/LebenssituationBild/LebenssituationBild"
import DownloadFileWidget from "../../anwendungskonfigurator/content/widgets/DownloadFileWidget"
import WidgetFragenkatalog from "../../anwendungskonfigurator/content/widgets/FrageListeWidget/WidgetFragenkatalog"
import WidgetFragenkatalogTabs
    from "../../anwendungskonfigurator/content/widgets/FrageListeWidget/WidgetFragenkatalogTabs"
import LeistungsmerkmalWidget from "./../../anwendungskonfigurator/content/widgets/LeistungsmerkmalWidget"
import ShowHideWidget from "../../anwendungskonfigurator/content/widgets/ShowHideWidget"
import ButtonSelectWidget from "../../anwendungskonfigurator/content/widgets/ButtonSelectWidget/ButtonSelectWidget"
import PDFCardWidget from "../../anwendungskonfigurator/content/widgets/PDFCardWidget"
import PaginationDisplay from "./../../anwendungskonfigurator/content/widgets/PaginationDisplay"
import DetailStackedBarchartWidget from "./../../anwendungskonfigurator/content/widgets/DetailStackedBarChart"
import DetailStackedGroupedBarChart from "./../../anwendungskonfigurator/content/widgets/DetailStackedGroupedBarChart"
import ErwerbsunfaehigkeitImage from "./../../anwendungskonfigurator/content/widgets/ErwerbsunfaehigkeitImage"
import LabelValueTable from "./../../anwendungskonfigurator/content/widgets/LabelValueTable"
import ValueDisplayTableWidget from "./../../anwendungskonfigurator/content/widgets/ValueDisplayTableWidget"
import ChartLegend from "../../anwendungskonfigurator/content/widgets/ChartLegend"
import SiStackedBarchartWidget from "../../anwendungskonfigurator/content/widgets/SiStackedBarChartWithBottomLabel"
import WidgetChipList from "../../anwendungskonfigurator/content/widgets/WidgetChipList"
import StackedDonutWidget from "../../anwendungskonfigurator/content/widgets/StackedDonutWidget"
import WidgetEmpty from "../../anwendungskonfigurator/content/widgets/WidgetEmpty"
import TextTemplater from "../../anwendungskonfigurator/content/widgets/TextTemplater/TextTemplater"
import EventsAndBarchartWidget
    from "../../anwendungskonfigurator/content/widgets/EventsAndBarchart/EventsAndBarchartWidget"
import AttributeInputWidget from "../../anwendungskonfigurator/content/widgets/AttributeInputWidget"
import AvRiesterTable from "../../anwendungskonfigurator/content/widgets/AvRiesterTable/AvRiesterTable"
import PraeferenzfragenGewichtungWidget
    from "../../anwendungskonfigurator/content/widgets/Altersvorsorgeberatung/PraeferenzfragenGewichtungWidget"
import AlertCard from "../../anwendungskonfigurator/content/widgets/AlertCard"
import ResponsiveSlider from "../../anwendungskonfigurator/content/widgets/ResponsiveSlider"
import PromillieWithFourDecimal from "./Widget/uwp-widgets/PromillieWithFourDecimal"
import SwitchToArrayWidget from "./Widget/uwp-widgets/SwitchToArrayWidget"
import RisikoortWidget from "./Widget/uwp-widgets/RisikoortWidget"
import BereicheWidget from "./Widget/uwp-widgets/BereicheWidget"
import ProduktErgebnisWidget from "./Widget/uwp-widgets/ProduktErgebnisWidget"
import SchadenhistorieWidget from "./Widget/uwp-widgets/SchadenhistorieWidget"
import BalkenDiagrammWidget from "./Widget/uwp-widgets/BalkenDiagrammWidget"
import ListEnumSelectWidget from "./Widget/uwp-widgets/ListEnumSelectWidget"
import MultiFreeInputSelectWidget from "./Widget/uwp-widgets/MultiFreeInputSelectWidget"
import PaginationWidget from "./Widget/uwp-widgets/PaginationWidget"
import ObjectListWithTwoDropAreas
    from "../../anwendungskonfigurator/content/widgets/WuenscheUndZiele/ObjectListIWthTwoDropAreas"
import LineChart from "../../anwendungskonfigurator/content/widgets/LineChart"
import WertentwicklungTable
    from "../../anwendungskonfigurator/content/widgets/AvRiesterTable/WertentwicklungTable"
import LeistungsphaseTable
    from "../../anwendungskonfigurator/content/widgets/AvRiesterTable/LeistungsphaseTable"
import FilterableSelectWidget from "../../anwendungskonfigurator/content/widgets/FilterableSelectWidget"

const ExcalidrawWidget = React.lazy(() => import("./../../anwendungskonfigurator/content/widgets/ExcalidrawWidget"))

export const WidgetMap = Object.freeze({
    OBJECTLISTWITHTWODROPAREAS: (props) => (
        <ObjectListWithTwoDropAreas {...props} />
    ),
    LINE_CHART: (props) => <LineChart {...props} />,
    WERTENTWICKLUNGTABLE: (props) => <WertentwicklungTable {...props} />,
    LEISTUNGSPHASE: (props) => <LeistungsphaseTable {...props} />,
    PRIMARYBUTTON: (props) => <PrimaryButtonWidget {...props} />,
    BUTTON: (props) => <PrimaryButtonWidget {...props} />, // UWP-Alias auf VW PrimaryButton
    SECONDARYBUTTON: (props) => <SecondaryButtonWidget {...props} />,
    TERTIARYBUTTON: (props) => <TertiaryButtonWidget {...props} />,
    GHOSTBUTTON: (props) => <GhostButtonWidget {...props} />,
    WORKFLOW_BUTTON: (props) => <WorkflowButtonWidget {...props} />,
    CHECKBOX: (props) => <CheckboxWidget {...props} />,
    CHILDRENSELECT: (props) => <ChildrenSelectWidget {...props} />,
    CHILDRENSELECTWITHENUM: (props) => (
        <ChildrenSelectWithEnumWidget {...props} />
    ),
    CURRENCY: (props) => <WidgetInputCurrency {...props} />,
    DATE: (props) => <DatePicker {...props} />,
    YEARPICKER: (props) => <YearPicker {...props} />,
    YEAR: (props) => <YearPicker {...props} />,
    DROPAREA: (props) => <WidgetDndBoard {...props} />,
    EDITOR: (props) => <WysiwygEditorWidget {...props} />,
    EMPTY: (props) => <WidgetEmpty {...props} />,
    ENUMERATION_SINGLE: (props) => <SelectWidget {...props} />,
    ENUMERATION_MULTI: (props) => <MultiSelectWidget {...props} />,
    ENUMERATION_SINGLE_ADDITIONAL: (props) => <ButtonSelectWidget {...props} />,
    PRAEFERENZFRAGEN_GEWICHTUNG: (props) => (
        <PraeferenzfragenGewichtungWidget {...props} />
    ),
    ALERT_CARD: (props) => <AlertCard {...props} />,
    FLOAT: (props) => <BaseTextInput {...props} />,
    ICONBUTTON: (props) => <IconButtonWidget {...props} />,
    IMAGE: (props) => <ImageWidget {...props} />,
    IMPORTFILEBUTTON: (props) => <ImportFileButtonWidget {...props} />,
    INTEGER: (props) => (
        <BaseTextInput
            type="number"
            {...props}
        />
    ),
    LABEL: (props) => <LabelWidget {...props} />,
    LINKVALUE: ({value, style}) => (
        <Link href="">
            <Typography style={style}>{value}</Typography>
        </Link>
    ),
    LONGTEXT: (props) => (
        <LongText
            {...props}
            rows={4}
        />
    ),
    MONETARYAMOUNT: (props) => <WidgetInputCurrency {...props} />,
    PDFCARD: (props) => <PDFCardWidget {...props} />,
    MULTISELECT: (props) => <MultiSelectWidget {...props} />,
    NUMBER: (props) => (
        <BaseTextInput
            type="number"
            {...props}
        />
    ),
    PERCENT: (props) => <PercentWithTwoDecimal {...props} />,
    PERCENTAGE: (props) => <PercentWithTwoDecimal {...props} />,
    OBJECTTOWIDGETS: (props) => <ObjektToWidgets {...props} />,
    SELECT: (props) => <SelectWidget {...props} />,
    FILTERSELECT: (props) => <FilterableSelectWidget {...props} />,
    STACKEDBARCHART: (props) => <StackedBarchartWidget {...props} />,
    STRING: (props) => <BaseTextInput {...props} />,
    SWITCH: (props) => <SwitchWidget {...props} />,
    TEXT: (props) => <BaseTextInput {...props} />,
    TEXT_TEMPLATER: (props) => <TextTemplater {...props} />,
    VALUE: (props) => <ValueWidget {...props} />,
    YESNO: (props) => <CheckboxWidget {...props} />,
    DONUT: (props) => <ChartDonutWidget {...props} />,
    ZIELSCHEIBE: (props) => <ZielscheibeWidget {...props} />,
    DRAGANDDROPDYNAMIK: (props) => <WidgetTimelineBoard {...props} />,
    DARTHONEY: (props) => <DartHoneyWidget {...props} />,
    HONEY: (props) => <HoneyWidget {...props} />,
    OBJECTLIST: (props) => <WidgetObjectList {...props} />,
    DIALOGMILESTONE: (props) => <DialogMilestoneContent {...props} />,
    VERTICALSLIDER: (props) => <VerticalSliderWidget {...props} />,
    RESPONSIVESLIDER: (props) => <ResponsiveSlider {...props} />,
    HORIZONTALSLIDER: (props) => <HorizontalSliderWidget {...props} />,
    BADGE: (props) => <BadgeWidget {...props} />,
    EVALUATIONBADGE: (props) => <BadgeEvaluationWidget {...props} />,
    MULTIDROPDOWN: (props) => <MultiDropdownWidget {...props} />,
    SEGMENTBUTTONS: (props) => <SegmentButtonWidget {...props} />,
    RADIOBUTTONGROUP: (props) => <RadiobuttonGroupWidget {...props} />,
    VERSORGUNGSLUECKENVERLAUFCHART: (props) => (
        <VersorgungslueckenVerlaufChart {...props} />
    ),
    DOT: (props) => <WidgetDot {...props} />,
    TETABLE: (props) => <WidgetTeTable {...props} />,
    ICONBUTTONOUTLINED: (props) => <IconButtonOutlined {...props} />,
    CUSTOMERLOGO: (props) => <WidgetLogo {...props} />,
    LINK: (props) => <WidgetLink {...props} />,
    ALTERSVORSORGEBERATUNGTABLE: (props) => (
        <AltersvorsorgeberatungTable {...props} />
    ),
    IMAGECARDPROGRESS: (props) => <ImageCardProgressWidget {...props} />,
    ICONCARD: (props) => <IconCardWidget {...props} />,
    FRAGELIST: (props) => <FrageListWidget {...props} />,
    WHITEBOARD: (props) => (
        <Suspense fallback={<CircularProgress />}>
            <ExcalidrawWidget {...props} />
        </Suspense>
    ),
    WELTBOARD: (props) => <WidgetWeltBoard {...props} />,
    HEROUNIT: (props) => <HeroUnitWidget {...props} />,
    ICON: (props) => <IconWidget {...props} />,
    LEBENSSITUATION_BILD: (props) => <LebenssituationBild {...props} />,
    VIDEO: (props) => <Video {...props} />,
    DOWNLOADFILEBUTTON: (props) => <DownloadFileWidget {...props} />,
    FRAGENKATALOG: (props) => <WidgetFragenkatalog {...props} />,
    FRAGENKATALOG_TABS: (props) => <WidgetFragenkatalogTabs {...props} />,
    PAGINATION: (props) => <PaginationDisplay {...props} />,
    SISTACKEDBARCHART: (props) => <SiStackedBarchartWidget {...props} />,
    DETAILSTACKEDBARCHART: (props) => (
        <DetailStackedBarchartWidget {...props} />
    ),
    DETAILSTACKEDGROUPEDBARCHART: (props) => (
        <DetailStackedGroupedBarChart {...props} />
    ),
    LABELVALUETABLE: (props) => <LabelValueTable {...props} />,
    VALUETABLE: (props) => <ValueDisplayTableWidget {...props} />,
    ERWERBSUNFAEHIGKEIT_IMAGE: () => <ErwerbsunfaehigkeitImage />,
    CHARTLEGEND: (props) => <ChartLegend {...props} />,
    LEISTUNGSMERKMAL: (props) => <LeistungsmerkmalWidget {...props} />,
    SHOWHIDE: (props) => <ShowHideWidget {...props} />,
    CHIPLIST: (props) => <WidgetChipList {...props} />,
    STACKEDDONUT: (props) => <StackedDonutWidget {...props} />,
    EVENTSANDBARCHART: (props) => <EventsAndBarchartWidget {...props} />,
    ATTRIBUTEINPUT: (props) => <AttributeInputWidget {...props} />,
    AVRIESTER_TABLE: (props) => <AvRiesterTable {...props} />,
    // UWP-Widgets (migriert)
    UWPPAGINATION: (props) => <PaginationWidget {...props} />,
    PROMILLIE: (props) => <PromillieWithFourDecimal {...props} />,
    SWITCHTOARRAY: (props) => <SwitchToArrayWidget {...props} />,
    CUSTOMWIDGET1: (props) => <RisikoortWidget {...props} />,
    CUSTOMWIDGET2: (props) => <BereicheWidget {...props} />,
    PRODUKTRESULT: (props) => <ProduktErgebnisWidget {...props} />,
    SCHADENSHISTORIE: (props) => <SchadenhistorieWidget {...props} />,
    BARCHART: (props) => <BalkenDiagrammWidget {...props} />,
    LISTENUMSELECT: (props) => <ListEnumSelectWidget {...props} />,
    MULTIFREEINPUTSELECT: (props) => <MultiFreeInputSelectWidget {...props} />,
})
